import { useState } from 'react';
import PropTypes from 'prop-types';
import 'intersection-observer';
import './styles.css';
import { ANSWER_COLORS_LIST } from '../constants';
import MarkdownParser from '../../Reports/widgets/MarkdownParser';
import { RESULT_ICONS, RESULT_TEXT } from '../../Reports/constants';
import RoundedButton from 'components/Shared/RoundedButton';
import { useSelector } from 'react-redux';
import { selectActivePatientInfo } from '../../../redux_store';

const InputSelect = ({ survey, isComparing, termsAcceptedTimestamp }) => {
  const { title, value, reportContent, baseValue, currentValue, comparison, drawingData, currentDrawingData, baseDrawingData } = survey;
  const valueUIClass = value ? value.valueUIClass : null;
  const valueTitle = value ? value.title : '';
  const content = <>
    {valueTitle || value}
    {drawingData && <ImageDataWidget drawingData={drawingData} termsAcceptedTimestamp={termsAcceptedTimestamp}/>}
  </>;

  return (
    <>
      {
        isComparing ?
          <tr className="list-break-marker">
            <td>
              <div>
                {title}
              </div>
            </td>
            <td className={baseValue?.valueUIClass}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                {baseValue?.title || baseValue || '-'}
                {baseDrawingData && <ImageDataWidget drawingData={baseDrawingData} termsAcceptedTimestamp={termsAcceptedTimestamp}/>}
              </div>
            </td>
            <td className={currentValue?.valueUIClass}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                {currentValue?.title || currentValue ||  '-'}
                {currentDrawingData &&
                  <ImageDataWidget drawingData={currentDrawingData} termsAcceptedTimestamp={termsAcceptedTimestamp}/>}
              </div>
            </td>
            <td className={comparison}>
              <div style={{
                justifyContent: comparison !== 'insufficient' ? null : 'center',
              }}>
                {
                  <>
                    {comparison !== 'insufficient' ? RESULT_TEXT[comparison] : '-'}
                    {RESULT_ICONS[comparison]}
                  </>
                }
              </div>
            </td>
          </tr> :
          <tr className="list-break-marker">
            <td>{title}</td>
            <td>
              {valueUIClass === ANSWER_COLORS_LIST.success ? content : ''}
            </td>
            <td>
              {valueUIClass === ANSWER_COLORS_LIST.warning ? content : ''}
            </td>
            <td>
              {valueUIClass === ANSWER_COLORS_LIST.error ? content : ''}
            </td>
            <td>
              {valueUIClass === ANSWER_COLORS_LIST.usual ||
              valueUIClass === ANSWER_COLORS_LIST.info ||
              !valueUIClass
                ? content
                : ''}
            </td>
          </tr>
      }
      {reportContent && (
        <tr className="list-break-marker">
          <td>
            <MarkdownParser content={reportContent} />
          </td>
        </tr>
      )}
    </>
  );
};

const ImageDataWidget = ({ drawingData, termsAcceptedTimestamp }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const patientInfo = useSelector(selectActivePatientInfo);
  const { en: { titles } } = useSelector((state) => state.i18n);

  const handleMouseEnter = () => {
    setIsVisible(true);
    setTimeout(() => setIsHovered(true), 10);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTimeout(() => setIsVisible(false), 300);
  };

  return (
    <>
      <div
        style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}
        onClick={handleMouseEnter}
      >
        <img
          src={drawingData}
          alt="Clock Drawing Test"
          className={'clock-image'}
          style={{ cursor: 'zoom-in' }}
        />
      </div>
      {isVisible && (
        <div
          style={{ backgroundColor: `rgba(0, 0, 0, ${isHovered ? 0.3 : 0})`}}
          className={'clock-image-fullscreen-container'}
          onClick={handleMouseLeave}
        >
          <div className={'clock-image-fullscreen-flex'}>
            <button
              onClick={handleMouseLeave}
              className={'clock-image-fullscreen-button'}
              style={{ opacity: isHovered ? 1 : 0}}
            >
              ×
            </button>
            <img
              src={drawingData}
              alt="Clock Drawing Test (Enlarged)"
              className={'clock-image-fullscreen-image'}
              style={{
                opacity: isHovered ? 1 : 0,
                transform: `scale(${isHovered ? 1 : 0.8})`,
              }}
            />
            <div style={{
              marginTop: '20px',
              opacity: isHovered ? 1 : 0,
              transition: 'all 0.3s ease-in-out',
            }}>
              <RoundedButton
                variant="contained"
                color="primary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  const link = document.createElement('a');
                  link.href = drawingData;
                  link.download = `Clock Drawing Test (${patientInfo.lastName}, ${patientInfo.firstName} - ${titles.testDate}: ${termsAcceptedTimestamp})`;// 'Clock Drawing Test ().png';
                  link.click();
                }}
              >
                Download Image
              </RoundedButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

InputSelect.propTypes = {
  survey: PropTypes.object,
};

InputSelect.defaultProps = {
  survey: {},
};

export default InputSelect;
